import React from 'react'
import WelcomeImg from "../Images/Ambassador.jpeg"
import "../CSS/WelcomePage.css"
import "animate.css"

const WelcomePage = () => {
  return (
    <div className='WelcomePage animate__animated animate__zoomInUp'>
      <img src={WelcomeImg} alt="welcome image"/>
        <h2>ENGINEER<br/> CHINEDU JOSEPH<br/> NDU</h2>
    </div>
  )
}

export default WelcomePage
